<!-- eslint-disable no-async-promise-executor -->
<template>
    <div @mouseenter="cancelDownload = true" @mouseleave="cancelDownload = false" class="upload-panel-wrapper" :style="cancelDownload?'min-width:100px':''" v-drag :class="{minHeight:isMaximised === true}">
        <div style="padding:3px">
            <img title="Downloading" :src="downloadingGif" alt="alto" style="width:90%;height:90%"/>
        </div>
        <div style="padding: 5px;color: #000;font-size:18px">{{getDownloadingFiles}}</div>
        <div v-if="cancelDownload" style="display: flex;align-items: center;">
            <cancel-icon style="fill:#000" @click.native="cancelDownloadAction"></cancel-icon>
        </div>
    </div>
</template>

<script>
import cancelIcon from "./InlineCancelField.vue"
import drag from '@branu-jp/v-drag'
import Utils from "../../components.utils.js";
import {  mapGetters, mapMutations, mapActions } from "vuex";
import Constants from "../../components.constants.js"

export default {
    directives: {
        drag
    },
    components:{
        'cancel-icon':cancelIcon,
    },
    data(){
        return{
            isMaximised:false,
            uploadedFilesCount:0,
            allJobsList:[],
            isFilters:false,
            selectedActionName:{action:"Jobs",label:"Jobs"},
            page:1,
            inProgressJobsCount:0,
            downloadingGif:Constants.downloadingGif,
            cancelDownload:false,
            downloadingFilesCount:0,
            aborted:false,
            dArray:[],
            addedDownloadArrays:[],
            downloadFilesNumbers: [],
            isAddingNewArray: false,
            SLEEP_TIME_BETWEEN_DOWNLOAD: 5000,//in millisecond,
        }
    }, 
    computed:{
        getDownloadingFiles(){
            let batchList = [];
            for(let key in this.getDownloadFilesArr){
                if(key && this.getDownloadFilesArr[key]){
                    batchList.push(...this.getDownloadFilesArr[key]);
                }
            }
            return (batchList.length - this.downloadFilesNumbers.length)
        },
        ...mapGetters("download",["getDownloadFilesArr"]),
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId"]),
    },
    methods:{
        ...mapActions("assets", ["getAssetInfoFromServer"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("privileges",["getActionListFromInMem"]),
        ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
        ...mapMutations("download",["removeFileFromDownloadQueue","cancelDownloadMultipleFiles","setCompletedStatus","unsetDownloadArray","unsetCurrentBatchList","unsetFilesTobBeDownloaded","unsetCurrentBatchKey"]),
        ...mapGetters("download",["getFileWithID"]),
        minMaxPanel(){
            this.isMaximised = !this.isMaximised;
        },
        getSvgIconsOfMediaTypes(path,type){
            return Utils.determineSvgIconForType(path,type)
        },
        closePanel(){
            this.$emit("closeUploadPanel");
            Utils.unsetCookie("jobFilter");
        },
        cancelDownloadAction(){
            if(confirm(`Are you sure you want to cancel download of selected files?`)){
                this.cancelDownloadMultipleFiles();
                this.aborted = true;
            }else{
                return false;
            }
        },
        resetPreviousBatchDownLoad(){
            this.unsetFilesTobBeDownloaded();
            this.downloadingFilesCount = 0;
            this.addedDownloadArrays = [];
            this.downloadFilesNumbers = [];
            this.isAddingNewArray = false;
        },
        isBatchDownloadCompleted(){
            let batchList = [];
            for(let key in this.getDownloadFilesArr){
                if(key && this.getDownloadFilesArr[key]){
                    batchList.push(...this.getDownloadFilesArr[key]);
                }
            }
            if(batchList.length === this.downloadFilesNumbers.length) return true;
            return false;
        },
         initiateDownloadFiles(dObject){
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve) => {
                let tempObj = dObject;
                if(Object.keys(tempObj).length){
                    let file = dObject
                    let payload = {};
                    let fileName = file.slug_name;
                    if(file.asset_type && file.asset_type == "subclip"){
                        let that = this;
                        let payloadTemp = {params:{assetId: file.master_asset_id}}
                        let parentAssetData = await that.getAssetInfoFromServer(payloadTemp);
                        if(parentAssetData["asset"]){
                            payload.bin_id = parentAssetData["asset"].bin_id;
                            payload.path = parentAssetData["asset"].path;
                            payload.file_name = parentAssetData["asset"].file_name;
                            fileName = parentAssetData["asset"].slug_name
                        }
                    }else{
                        payload.bin_id = file.bin_id;
                        payload.path = file.path;
                        payload.file_name = file.file_name;
                    }
                    payload.element_type = "file";
                    let isProxyDownload = ('download_proxy' in file && file.download_proxy);
                    if(isProxyDownload){
                        payload.job_name = "Download Proxy";
                    }else{
                        payload.job_name = "Download";
                    }
                    console.log("fileName",fileName)
                    this.initiateDownloadJob(payload).then((data) => {
                        let jobIdFromResponse = data.job_id;
                        let jobFileName = data.file_name;
                        let payloadTemp = {};
                        payloadTemp = { job_id: "job_id=" + jobIdFromResponse };
                        const link = document.createElement("a");
                        if(isProxyDownload){
                            link.href = `${Constants.downloadProxyUrl}?${payloadTemp.job_id}`;
                            link.download = jobFileName;
                        }else{
                            link.href = `${Constants.downloadUrl}?${payloadTemp.job_id}`;
                            console.log("fileNamefileName",fileName)
                            link.download = fileName;
                        }
                        link.click(); 
                        resolve(dObject)
                        if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
                            console.log("Download initiated");
                        }
                    })
                }
            }) 
        },

        async downloadFilesInQueue(){
            async function* downloadBatchGenerator() {
                for(let key in this.getDownloadFilesArr){
                    if(key && this.getDownloadFilesArr[key]){
                        for(let i = 0; i < this.getDownloadFilesArr[key].length; i++){
                            yield this.getDownloadFilesArr[key][i];
                        }
                    } 
                }

                while (this.addedDownloadArrays.length > 0) {
                    const addedArray = this.addedDownloadArrays.shift();
                    for (let i = 0; i < addedArray.length; i++) {
                        yield addedArray[i];
                    }
                }
            }

            const gen = downloadBatchGenerator.bind(this)();

            for await (let n of gen) {
                await new Promise(resolve => {
                    setTimeout(() => {
                        if(this.aborted){
                            gen.throw(new Error('Aborting File Download'));
                            this.resetPreviousBatchDownLoad(); // pause is required then comment this line
                            this.$emit('hideDownloadPanel');
                        }
                        this.downloadFilesNumbers.push(n);
                        this.initiateDownloadFiles(n);
                        try{
                          console.log(`[Completed download of] ${n.file_name}`);
                        }catch(e){console.log(e)}
                        if(this.isBatchDownloadCompleted()){
                            this.resetPreviousBatchDownLoad();
                            setTimeout(() => {
                                this.downloadFilesInQueue();
                                this.$emit('hideDownloadPanel');
                            },0);
                        }
                        resolve();
                    }, this.SLEEP_TIME_BETWEEN_DOWNLOAD);
                });
            }

            if (this.isAddingNewArray) {
                return;
            }
        }
    },
    watch:{
        "$store.state.download.currentBatch.key":{
            handler:function(newVal, oldVal){ 
                console.log(newVal, oldVal);
                if(this.getDownloadFilesArr && Array.isArray(this.getDownloadFilesArr) && Object.keys(this.getDownloadFilesArr).length == 1){
                    this.downloadFilesInQueue();
                }else{
                    this.isAddingNewArray = true;
                    // let counter = Object.keys(this.downloadArray).length + 1;
                    let newArray = this.$store.state.download.currentBatch.value;//this.$store.state.download.filesToBeDownloaded[this.$store.state.download.lastDownloadBatchID];
                    this.addedDownloadArrays.push(newArray);
                    this.unsetCurrentBatchList();
                    this.isAddingNewArray = false;
                }
            }
        },
    },
    created(){ 
        this.downloadFilesInQueue()
    },
    beforeDestroy(){
        // this.unsetCurrentBatchKey();
    }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.active{
    color:$active-blue;
}

.filters-bar{
    max-height: 190px;
    width: 100%;
    overflow:auto;
    display:inline-block;
    ul{
        list-style-type: none;
        padding-inline-start:2px;
        li{
            text-align: start;
            margin-inline-start: 6%;
            margin-top: 9px;
        }
    }
}
.upload-panel-wrapper{
    border: 1px solid #2b2b2b;
    position: absolute;
    bottom: 1px !important;
    top: unset !important;
    inset-inline-end: 0.5%;
    z-index: 9;
    height: auto;
    min-width: 75px;
    width: min-content;
    border-radius: 30px;
    padding: 2px;
    background: #1fa0e0;
    display: flex;
    .close-or-min-panel{
            height: 50px;
            width:100%;
            border-bottom: $secondary-border-color;
            background: $secondary-background-color;
            text-align: end;
            padding: 5px;
            display: flex;
            justify-content: flex-end;
        }
    .upload-progress-bar{
            max-height: 190px;
            width: 100%;
            padding-top: 7px;
            overflow:auto;
            display:inline-block;
            .edit-upload-info{
                width:8%;
                padding: 5px;
                    svg{
                        position: relative;
                        inset-inline-end: 6px;
                    }
            }
            .file-name-with-progress-bar-wrapper{
                    display: inline-flex;
                    width: 93%;
                    .file-name-wrapper{
                        width: 99%;
                        display: inline-block;
                        .file-name-display{
                            text-align: start;
                            /* white-space: nowrap; */
                            overflow-wrap: break-word;
                            width: 277px;
                            /* overflow: hidden; */
                            /* text-overflow: ellipsis;*/
                            span{
                                    font-size: 11px;
                                    color: #dbdbdb;
                            }
                        }
                        .upload-status-text{
                            text-align: start;
                            float:inline-start;
                            font-size:11px;
                            margin-inline-start:8px;
                            color:#8d8d8d;
                        }
                        .progress-bar-wrapper{
                                display: inline-flex;
                                width: 100%;
                                .progress-percentage-display{
                                        font-size: 11px;
                                }
                                .progress{
                                    width: 67%;
                                    background: #292929;
                                    margin-inline-start: 4px;
                                    height: 10px;
                                    margin-top: 2px;
                                    border-radius: 3px;
                                }
                                .progress-speed-display{
                                        font-size: 11px;
                                        margin-inline-start: 3px;
                                }
                        }
                    }
                }
                .file-upload-status-display-wrapper{
                        width:20%;
                        .file-upload-status{
                            height: 30px;
                            margin-top: 8px;
                            display:inline-flex;
                        }
                    }
            }
        }



.edit-upload-info{
    position: relative;
    inset-inline-start:0px;
}

.minHeight{
    height:52px !important;
    bottom:1px !important;
    top: unset !important;
}

.dragged-element {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    font-size: 12px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    text-align: center;
    transition: all 0.4s linear;
    transition-property: background-color;
  }

.remove-selected-file{
  visibility:hidden;
}

.upload-bars:hover{
  .remove-selected-file{
    visibility: visible;
    position: relative;
    bottom: 6px;
  }
} 

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.upload-bars{
    margin-bottom: 12px;
}
.back-button-wrapper{
    width: 90%;
    float: inline-start;
    padding-top: 1%;
    svg{
        float: inline-start;
    }
    svg:hover{
        background: $icon-hover !important;
    }
}

.filterpanel{
    visibility: hidden;
}
.close-or-min-panel:hover{
    .filterpanel{
        visibility: visible;
    }
}
</style>



